import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    gallery: 'hidden sm:block',
    title: '!font-[450]',
    tabs: 'sm:mb-5'
  }
});
